import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcelWithoutDisplayNone,
  DownloadDataFile,
  FilterJsonExactlyMatching,
  formateDate,
  formateDateWithTime,
  getDateMinusMonths,
  getEndOfMonth,
  getEndPreviousMonth,
  getStartOfMonth,
  getStartOfPreviousMonth,
  getToday,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import MultiSelectionDropdown from "../App/MultiSelectionDropdown";
import LockUnlock from "../App/LockUnlock";
import { showErrorMessage, showSuccessMessage } from "../Shared/Toast";

function Customers() {
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();
  const SelectedOrderNumber: any = searchParams.get("j");

  const [isAnimation, setIsAnimation] = useState(false);
  const [isDetailView, setIsDetailView] = useState(false);
  const [detailViewData, setDetailViewData] = useState<any>([]);
  const [isLocked, setIsLocked] = useState(false);
  const [FilterObjectObject, setFilterObjectObject] = useState<any>({
    StartDate: getDateMinusMonths(3),
    EndDate: getToday(),
    UserName: "",
    Email: "",
    OrderNumber: "",
    InvoiceNumber: "",
    InvoiceType: 0,
    Status: 0,
    Month: 4,
  });
  const [StatusStatus, setStatusStatus] = useState<any>([]);
  const [CampaignFilterList, setCampaignFilterList] = useState<any>([]);
  const [Totals, setTotals] = useState<any>({});
  const [EditObject, setEditObject] = useState<any>({});
  const [editModal, seteditModal] = useState(false);
  const [ShowFilters, SetShowFilters] = useState(true);
  const ShowHideFilters = () => {
    SetShowFilters(!ShowFilters);
  };
  const [ShowConfirmedOrders, SetShowConfirmedOrders] = useState(false);
  const ShowHideConfirmedOrders = () => {
    SetShowConfirmedOrders(!ShowConfirmedOrders);
  };
  const [ShowCancelledOrders, SetShowCancelledOrders] = useState(false);
  const ShowHideCancelledOrders = () => {
    SetShowCancelledOrders(!ShowCancelledOrders);
  };

  const [customerDetails, setCustomerDetails] = useState(true);
  const [billingInfo, setBillingInfo] = useState(true);
  const [shippingInfo, setShippingInfo] = useState(true);
  const [orderDetails, setOrderDetails] = useState(true);
  const [productDetails, setProductDetails] = useState(true);

  useEffect(() => {
    let fromDateStr = "";
    let toDateStr = "";
    if (FilterObjectObject.Month == 1) {
      fromDateStr = getStartOfMonth();
      toDateStr = getEndOfMonth();
    } else if (FilterObjectObject.Month == 2) {
      fromDateStr = getStartOfPreviousMonth();
      toDateStr = getEndPreviousMonth();
    } else if (FilterObjectObject.Month == 3) {
      fromDateStr = getDateMinusMonths(1);
      toDateStr = getToday();
    } else if (FilterObjectObject.Month == 4) {
      fromDateStr = getDateMinusMonths(3);
      toDateStr = getToday();
    }

    setFilterObjectObject((prevState: any) => ({
      ...prevState,
      StartDate: fromDateStr,
      EndDate: toDateStr,
    }));
  }, [FilterObjectObject.Month]);

  useEffect(() => {
    loadAdminDataForOrders();
  }, []);

  function ClearFilter() {
    FilterObjectObject.StartDate = getDateMinusMonths(1);
    FilterObjectObject.EndDate = getToday();
    FilterObjectObject.UserName = "";
    FilterObjectObject.Email = "";
    FilterObjectObject.OrderNumber = "";
    FilterObjectObject.InvoiceNumber = "";
    FilterObjectObject.Status = 0;
    FilterObjectObject.Month = 1;

    setFilterObjectObject((prevState: any) => ({
      ...prevState,
      StartDate: getDateMinusMonths(1),
      EndDate: getToday(),
      UserName: "",
      Email: "",
      OrderNumber: "",
      InvoiceNumber: "",
      Status: 0,
      Month: 1,
    }));
    loadAdminDataForOrders();
  }

  function loadAdminDataForOrders(pid: any = 0) {
    setIsAnimation(true);
    let data = {} as any;
    data.startdate = FilterObjectObject.StartDate;
    data.enddate = FilterObjectObject.EndDate;
    data.pid = -101;
    data.status = pid;
    data.name = FilterObjectObject.UserName;
    data.email = FilterObjectObject.Email;
    data.invoicenumber = FilterObjectObject.InvoiceNumber;
    data.ordernumber = FilterObjectObject.OrderNumber;
    setDetailViewData([]);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/LoadAdminDataForOrders", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse[0]));
          if (pid == 0) {
            setThisGridListDataWithoutFilters(deepCopy1);
            setThisGridListData(deepCopy2);
            thisGridListDataRef.current = deepCopy2;
            setIsDetailView(false);
          } else {
            setDetailViewData(deepCopy1);
            setIsDetailView(true);
          }
          console.log("l_oResponse", l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function GetCampaignFilterList() {
    axiosAuth
      .get(AppContext.APIURL + "api/SiteUser/PTCampaignGetCompleteGridData")
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false,
          );
          for (let index = 0; index < l_oResponse.length; index++) {
            l_oResponse[index].PID = l_oResponse[index].PTCampaignID;
          }
          setCampaignFilterList(l_oResponse);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function SaveInvoiceData(
    Type: any,
    Index: any,
    PTPaymentIndividualInvoiceID: any,
  ) {
    let data = {} as any;
    data.Type = Type;
    data.PTPaymentIndividualInvoiceID = PTPaymentIndividualInvoiceID;
    data.Name = thisGridListData[Index].Name;
    data.EmailAddress = thisGridListData[Index].EmailAddress;
    data.CompanyName = thisGridListData[Index].CompanyName;
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/UpdateInvoicesDataAdmin", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0][0];
          let l_data = [...thisGridListData];
          l_data[Index].PDFURL = l_oResponse.PDFURL;

          setThisGridListData(l_data);
          thisGridListDataRef.current = l_data;
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function SendInvoice(PTPaymentIndividualInvoiceID: any) {
    var data: any = {} as any;
    data.PTPaymentIndividualInvoiceID = PTPaymentIndividualInvoiceID;
    setIsAnimation(true);

    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/SendInvoice", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0][0];

          if (l_oResponse.Status == 1) {
            showSuccessMessage(l_oResponse.Message);
          } else {
            showErrorMessage(l_oResponse.Message);
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function GenerateInvoicePDF(PTPaymentIndividualInvoiceID: any, Index: any) {
    var data: any = {} as any;
    data.PTPaymentIndividualInvoiceID = PTPaymentIndividualInvoiceID;
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/GenerateInvoicePDF", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0][0];
          if (l_oResponse.PDFURL.length > 0) {
            let l_data = [...thisGridListData];
            l_data[Index].PDFURL = l_oResponse.PDFURL;
            setThisGridListData(l_data);
            thisGridListDataRef.current = l_data;
            DownloadDataFile(
              l_oResponse.PDFName,
              l_oResponse.PDFURL.includes(".co.uk")
                ? l_oResponse.PDFURL
                : AppContext.APIURL + l_oResponse.PDFURL,
            );
          } else {
            showErrorMessage("There is some issue. Please conatct support.");
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function DownloadInvoicePDF(PTPaymentIndividualInvoiceID: any, Index: any) {
    var data: any = {} as any;
    data.PTPaymentIndividualInvoiceID = PTPaymentIndividualInvoiceID;
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/SiteUser/DownloadInvoicePDF", data)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0][0];
          if (l_oResponse.PDFURL.length > 0) {
            let l_data = [...thisGridListData];
            l_data[Index].PDFURL = l_oResponse.PDFURL;
            setThisGridListData(l_data);
            thisGridListDataRef.current = l_data;
            DownloadDataFile(
              l_oResponse.PDFName,
              l_oResponse.PDFURL.includes(".co.uk")
                ? l_oResponse.PDFURL
                : AppContext.APIURL + l_oResponse.PDFURL,
            );
          } else {
            showErrorMessage("There is some issue. Please conatct support.");
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function SaveEditedInvoiceData() {
    var data: any = {} as any;
    data.PTPaymentIndividualInvoiceID = EditObject.PTPaymentIndividualInvoiceID;
    data.CompanyName = EditObject.CompanyName;
    data.Name = EditObject.Name;
    data.EmailAddress = EditObject.EmailAddress;
    data.ZipCode = EditObject.ZipCode;
    data.AddressLine1 = EditObject.AddressLine1;
    data.AddressLine2 = EditObject.AddressLine2;
    data.CompanyNumber = EditObject.CompanyNumber;
    data.VATNumber = EditObject.VATNumber;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/SiteUser/UpdateEditedInvoicesDataAdmin",
        data,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
        }
        seteditModal(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function SetTotal() {
    var TotalReceived = 0;
    var TotalRefunded = 0;
    var VATCollection = 0;
    var VATRefunded = 0;
    for (var i = 0; i < thisGridListData.length; i++) {
      if (thisGridListData[i].ObjectType == 1) {
        TotalReceived += thisGridListData[i].TotalAmount;
        if (thisGridListData[i].TotalAmount > 0)
          VATCollection += thisGridListData[i].VATAmount;
      } else if (thisGridListData[i].ObjectType == 2) {
        TotalRefunded += thisGridListData[i].TotalAmount;
        VATRefunded += thisGridListData[i].VATAmount;
      }
    }
    let thistotal = {} as any;
    thistotal.TotalReceived = TotalReceived?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    thistotal.TotalRefunded = TotalRefunded?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    thistotal.VATCollection = VATCollection?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    thistotal.VATRefunded = VATRefunded?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    setTotals(thistotal);
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(
      JSON.stringify(thisGridListDataWithoutFilters[0]),
    );
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      const firstRow = thisGridListData[0];
      Object.keys(firstRow).forEach((col) => {
        const element = document.getElementById("imgSort" + col);

        if (element) {
          element.innerHTML =
            '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
        }
      });
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  function updateSelectedPIDForParent(type: any, value: any, name: any) {
    if (type == 1) {
      FilterObjectObject.CampaignCode = value;
      setFilterObjectObject((prevState: any) => ({
        ...prevState,
        CampaignCode: value,
      }));
    }
  }

  useEffect(() => {
    if (thisGridListData && thisGridListData.length > 0) SetTotal();
  }, [thisGridListData]);

  function updatedata(index: number, value: any, colname: any) {
    let tempArray = [...thisGridListData];
    tempArray[index][colname] = value;
    setThisGridListData(tempArray);
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      <>
        {isDetailView == false && (
          <>
            <div
              className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer"
              onClick={ShowHideFilters}
            >
              Filters
              <img
                className={` ${ShowFilters ? "rotate-180" : ""}`}
                src="images/chev-down.svg"
                width={16}
                height={16}
              />
            </div>
            {ShowFilters && (
              <div className="inline-block-d text-center width-100 reuse-border p-all20">
                <div className="grid-d fr-1111 flex-gap10">
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">Month</span>
                    <select
                      value={FilterObjectObject.Month}
                      onChange={(e) => {
                        FilterObjectObject.Month = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          Month: e.target.value,
                        }));
                      }}
                      className="input-field w-100"
                    >
                      <option value="1">This Month</option>
                      <option value="2">Last Month</option>
                      <option value="3">Last 30 Days</option>
                      <option value="4">Last 90 Days</option>
                    </select>
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Start Date
                    </span>
                    <input
                      type="Date"
                      className="input-field w-100"
                      value={moment(FilterObjectObject.StartDate).format(
                        "YYYY-MM-DD",
                      )}
                      onChange={(e) => {
                        FilterObjectObject.StartDate = moment(
                          e.target.value,
                        ).format("YYYY-MM-DD");
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          StartDate: moment(e.target.value).format(
                            "YYYY-MM-DD",
                          ),
                        }));
                      }}
                    />
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      End Date
                    </span>
                    <input
                      type="Date"
                      className="input-field w-100"
                      value={moment(FilterObjectObject.EndDate).format(
                        "YYYY-MM-DD",
                      )}
                      onChange={(e) => {
                        FilterObjectObject.EndDate = moment(
                          e.target.value,
                        ).format("YYYY-MM-DD");
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          EndDate: moment(e.target.value).format("YYYY-MM-DD"),
                        }));
                      }}
                    />
                  </div>

                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Customer Name
                    </span>
                    <input
                      type="text"
                      className="input-field w-100"
                      value={FilterObjectObject.UserName}
                      onChange={(e) => {
                        FilterObjectObject.UserName = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          UserName: e.target.value,
                        }));
                      }}
                    />
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Customer Email
                    </span>
                    <input
                      type="text"
                      className="input-field w-100"
                      value={FilterObjectObject.Email}
                      onChange={(e) => {
                        FilterObjectObject.Email = e.target.value;
                        setFilterObjectObject((prevState: any) => ({
                          ...prevState,
                          Email: e.target.value,
                        }));
                      }}
                    />
                  </div>
                </div>
                <div className="flex-daj btn-start flex-gap10 mt-10">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => loadAdminDataForOrders()}
                  >
                    Apply Filter
                  </a>
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => ClearFilter()}
                  >
                    Clear Filter
                  </a>
                </div>
              </div>
            )}
            <>
              <div className="flex-da justify-end mt-10 mb-10 flex-gap10">
                <div className="flex-daj flex-gap10">
                  <a
                    className="link-btn btn-link-m"
                    onClick={() => ClearAllFilters()}
                  >
                    Clear All Filters
                  </a>
                  <a
                    className="btn-primary flex-daj btn-grid"
                    title="Export"
                    onClick={() =>
                      DownloadClientsDataInExcelWithoutDisplayNone(
                        "tblcampaigndata",
                        "Customers " + moment().format("DD-MM-YY HH-mm-ss"),
                      )
                    }
                  >
                    <img src="images/export.svg" width="18" height="18" />
                  </a>
                  {/* <LockUnlock locked={isLocked} setLocked={setIsLocked}></LockUnlock> */}
                </div>{" "}
              </div>
              <div className="flow-auto-lg5">
                <table className="reuse-table" id="tblcampaigndata">
                  <thead>
                    {/* <tr>
                      <th colSpan={5}></th>
                      <th colSpan={5}>Billing Address</th>
                      <th colSpan={5}>Shipping Address</th>
                    </tr> */}
                    <tr>
                      <th className="reuse-tdxs">Action</th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Creation Date
                            <a
                              onClick={(e) => ShowColumnFilterList(e, "Dated")}
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("Dated")}
                              title={"Sort By Dated"}
                            >
                              <span id={"imgSort" + "Dated"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            First Name
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "FirstName")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("FirstName")}
                              title={"Sort By FirstName"}
                            >
                              <span id={"imgSort" + "FirstName"}></span>
                            </a>
                          </div>
                        </div>
                      </th>

                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Last Name
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "LastName")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("LastName")}
                              title={"Sort By LastName"}
                            >
                              <span id={"imgSort" + "LastName"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Email
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "EmailAddress")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("EmailAddress")
                              }
                              title={"Sort By EmailAddress"}
                            >
                              <span id={"imgSort" + "EmailAddress"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Mobile
                            <a
                              onClick={(e) => ShowColumnFilterList(e, "Mobile")}
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("Mobile")}
                              title={"Sort By Mobile"}
                            >
                              <span id={"imgSort" + "Mobile"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      {/* <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Post Code
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "PostCode")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("PostCode")}
                              title={"Sort By PostCode"}
                            >
                              <span id={"imgSort" + "PostCode"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            House Number
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "HouseNumber")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("HouseNumber")
                              }
                              title={"Sort By HouseNumber"}
                            >
                              <span id={"imgSort" + "HouseNumber"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Address Line 1
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "AddressLine1")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("AddressLine1")
                              }
                              title={"Sort By AddressLine1"}
                            >
                              <span id={"imgSort" + "AddressLine1"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Address Line 2
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "AddressLine2")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("AddressLine2")
                              }
                              title={"Sort By AddressLine2"}
                            >
                              <span id={"imgSort" + "AddressLine2"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            City
                            <a
                              onClick={(e) => ShowColumnFilterList(e, "City")}
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() => LoadWithSelectedSort("City")}
                              title={"Sort By City"}
                            >
                              <span id={"imgSort" + "City"}></span>
                            </a>
                          </div>
                        </div>
                      </th>

                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Post Code
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "ShippingPostCode")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("ShippingPostCode")
                              }
                              title={"Sort By PostCode"}
                            >
                              <span id={"imgSort" + "ShippingPostCode"}></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            House Number
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "ShippingHouseNumber")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("ShippingHouseNumber")
                              }
                              title={"Sort By HouseNumber"}
                            >
                              <span
                                id={"imgSort" + "ShippingHouseNumber"}
                              ></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Address Line 1
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "ShippingAddressLine1")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("ShippingAddressLine1")
                              }
                              title={"Sort By AddressLine1"}
                            >
                              <span
                                id={"imgSort" + "ShippingAddressLine1"}
                              ></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            Address Line 2
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "ShippingAddressLine2")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("ShippingAddressLine2")
                              }
                              title={"Sort By AddressLine2"}
                            >
                              <span
                                id={"imgSort" + "ShippingAddressLine2"}
                              ></span>
                            </a>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div className="flex-daj flex-gap20">
                          <div className="flex-da flex-gap5">
                            City
                            <a
                              onClick={(e) =>
                                ShowColumnFilterList(e, "ShippingCity")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              <img
                                src="images/icon-search-w.svg"
                                width={15}
                                height={15}
                                alt="search"
                              />
                            </a>
                            <a
                              onClick={() =>
                                LoadWithSelectedSort("ShippingCity")
                              }
                              title={"Sort By City"}
                            >
                              <span id={"imgSort" + "ShippingCity"}></span>
                            </a>
                          </div>
                        </div>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {thisGridListData &&
                      thisGridListData.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          {!item.IsExcluded && (
                            <tr>
                              <td className="text-center reuse-tdxs">
                                <div className="flex-daj gap-10">
                                  <a
                                    title="View Details"
                                    onClick={() => {
                                      loadAdminDataForOrders(item.PID);
                                    }}
                                  >
                                    <img
                                      src="images/eye-t.svg"
                                      width="22px"
                                      height="22px"
                                      alt="Edit"
                                    />
                                  </a>
                                </div>
                              </td>
                              <td>{formateDate(item.Dated)}</td>
                              <td>{item.FirstName}</td>
                              <td>{item.LastName}</td>
                              <td>{item.EmailAddress}</td>
                              <td>{item.Mobile}</td>
                              {/* <td>{item.PostCode}</td>
                              <td>{item.HouseNumber}</td>
                              <td>{item.AddressLine1}</td>
                              <td>{item.AddressLine2}</td>
                              <td>{item.City}</td>

                              <td>{item.ShippingPostCode}</td>
                              <td>{item.ShippingHouseNumber}</td>
                              <td>{item.ShippingAddressLine1}</td>
                              <td>{item.ShippingAddressLine2}</td>
                              <td>{item.ShippingCity}</td> */}
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          </>
        )}

        {isDetailView == true && detailViewData[0] && detailViewData[0][0] && (
          <>
            <div className="flex-da justify-end mt-10 mb-10 flex-gap10">
              <div className="flex-daj flex-gap10">
                <a
                  className="link-btn btn-link-m"
                  onClick={() => loadAdminDataForOrders(0)}
                >
                  Back
                </a>
              </div>
            </div>
            <div className="grid-d gap-10 fr-111 flex-as font-12">
              <div className="grid-d">
                <div
                  className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only"
                  // onClick={() => setCustomerDetails(!customerDetails)}
                >
                  Customer Details
                  {/* <img
                    className={` ${customerDetails ? "rotate-180" : ""}`}
                    src="images/chev-down.svg"
                    width={16}
                    height={16}
                  /> */}
                </div>
                {customerDetails && (
                  <div className="inline-block-d text-center width-100 reuse-border p-all20">
                    {detailViewData[0] && detailViewData[0][0] && (
                      <div className="grid-d fr-1 flex-gap10">
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">First Name:</span>
                          <span>{detailViewData[0][0].FirstName}</span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">Last Name:</span>
                          <span>{detailViewData[0][0].LastName}</span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">Email:</span>
                          <span>{detailViewData[0][0].EmailAddress}</span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">Mobile:</span>
                          <span>{detailViewData[0][0].Mobile}</span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="grid-d">
                <div
                  className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only"
                  // onClick={() => setBillingInfo(!billingInfo)}
                >
                  Billing Information
                  {/* <img
                    className={` ${billingInfo ? "rotate-180" : ""}`}
                    src="images/chev-down.svg"
                    width={16}
                    height={16}
                  /> */}
                </div>
                {billingInfo && (
                  <div className="inline-block-d text-center width-100 reuse-border p-all20">
                    {detailViewData[0] && detailViewData[0][0] && (
                      <div className="grid-d fr-1 flex-gap10">
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">Post code:</span>
                          <span>{detailViewData[0][0].PostCode}</span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">
                            House Number:
                          </span>
                          <span>{detailViewData[0][0].HouseNumber}</span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">
                            1 Line of address:
                          </span>
                          <span>{detailViewData[0][0].AddressLine1}</span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">
                            2 Line of address:
                          </span>
                          <span>{detailViewData[0][0].AddressLine2}</span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">City/Town:</span>
                          <span>{detailViewData[0][0].City}</span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="grid-d">
                <div
                  className="accordion-top flex-da justify-btw grey-accord mtb-0 pointer mt-10 mt-only"
                  // onClick={() => setShippingInfo(!shippingInfo)}
                >
                  Shipping Information
                  {/* <img
                    className={` ${shippingInfo ? "rotate-180" : ""}`}
                    src="images/chev-down.svg"
                    width={16}
                    height={16}
                  /> */}
                </div>
                {shippingInfo && (
                  <div className="inline-block-d text-center width-100 reuse-border p-all20">
                    {detailViewData[0] && detailViewData[0][0] && (
                      <div className="grid-d fr-1 flex-gap10">
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">Post code:</span>
                          <span>{detailViewData[0][0].ShippingPostCode}</span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">
                            House Number:
                          </span>
                          <span>
                            {detailViewData[0][0].ShippingHouseNumber}
                          </span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">
                            1 Line of address:
                          </span>
                          <span>
                            {detailViewData[0][0].ShippingAddressLine1}
                          </span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">
                            2 Line of address:
                          </span>
                          <span>
                            {detailViewData[0][0].ShippingAddressLine2}
                          </span>
                        </div>
                        <div className="flex-d gap-10 flex-ac font-mont">
                          <span className="data-txt font-12">City/Town:</span>
                          <span>{detailViewData[0][0].ShippingCity}</span>
                        </div>
                      </div>
                    )}
                    {/* {detailViewData[0] &&
                      detailViewData[0][0] &&
                      detailViewData[0][0].SameBothAddress == 1 && (
                        <div className="grid-d fr-1 flex-gap10">
                          <div className="flex-d gap-10 flex-ac font-mont">
                            <input type="checkbox" checked disabled />
                            <span>Same As Billing Address</span>
                          </div>
                        </div>
                      )} */}
                  </div>
                )}
              </div>
            </div>

            {productDetails && (
                <div className="flow-auto-lg3 mt-10 mb-10 flex-gap10">
                  <table className="reuse-table" id="tblcampaigndata">
                    <thead>
                      <tr>
                        <th colSpan={5}></th>
                        <th colSpan={5}>Billing Address</th>
                        <th colSpan={5}>Shipping Address</th>
                      </tr>
                      <tr>
                        <th>Dated</th>
                        <th>First Name</th>

                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Post Code</th>
                        <th>House Number</th>
                        <th>Address Line 1</th>
                        <th>Address Line 2</th>
                        <th>City</th>
                        <th>Post Code</th>
                        <th>House Number</th>
                        <th>Address Line 1</th>
                        <th>Address Line 2</th>
                        <th>City</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailViewData[1] &&
                        detailViewData[1].map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            {!item.IsExcluded && (
                              <tr>
                                <td className="text-left">{formateDate(item.Dated)}</td>
                                <td className={item.FNST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.FirstName}
                                </td>
                                <td className={item.LNST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.LastName}
                                </td>
                                <td className={item.EMST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.EmailAddress}
                                </td>
                                <td className={item.MBST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.Mobile}
                                </td>
                                <td className={item.P1ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.PostCode}
                                </td>
                                <td className={item.H1ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.HouseNumber}
                                </td>
                                <td className={item.A11ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.AddressLine1}
                                </td>
                                <td className={item.A21ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.AddressLine2}
                                </td>
                                <td className={item.CT1ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.City}
                                </td>
                                <td className={item.P2ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.ShippingPostCode}
                                </td>
                                <td className={item.H2ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.ShippingHouseNumber}
                                </td>
                                <td className={item.A22ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.ShippingAddressLine1}
                                </td>
                                <td className={item.A22ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.ShippingAddressLine2}
                                </td>
                                <td className={item.CT2ST == 1 ? "c-red text-left" : "text-left"}>
                                  {item.ShippingCity}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
            )}
          </>
        )}
      </>

      {editModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup">
              <div className="help-head flex-da justify-btw">
                <div className="flex-daj flex-gap20">
                  <h3 className="bold-font flex-d m-all0">
                    <span>Invoice Number : {EditObject.InvoiceNumber} </span>
                  </h3>
                  <h3 className="bold-font flex-d m-all0">
                    <span> OrderNumber : {EditObject.OrderNumber}</span>
                  </h3>
                </div>
                <a className="close-help" onClick={() => seteditModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="popup-message mt-20 p-all0">
                <div className="grid-d fr-1111 gap-20">
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Business Name
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Business Name"
                      type="text"
                      value={EditObject.CompanyName}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          CompanyName: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Client Name
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Client Name"
                      type="text"
                      value={EditObject.Name}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          Name: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Client Email
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Client Email"
                      type="text"
                      value={EditObject.EmailAddress}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          EmailAddress: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Address Line 1
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Address Line 1"
                      type="text"
                      value={EditObject.AddressLine1}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          AddressLine1: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Address Line 2
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Address Line 2"
                      type="text"
                      value={EditObject.AddressLine2}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          AddressLine2: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Post Code
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Post Code"
                      type="text"
                      value={EditObject.ZipCode}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          ZipCode: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Company Number
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="Company Number"
                      type="text"
                      value={EditObject.CompanyNumber}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          CompanyNumber: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      VAT Number
                    </span>
                    <input
                      className="input-field w-100"
                      placeholder="VAT Number"
                      type="text"
                      value={EditObject.VATNumber}
                      onChange={(e) =>
                        setEditObject((prevState: any) => ({
                          ...prevState,
                          VATNumber: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => SaveEditedInvoiceData()}
                  >
                    Update
                  </a>
                </div>
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => seteditModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Customers;
